
import { FSXABaseComponent } from 'fsxa-pattern-library'
import { Component } from 'nuxt-property-decorator'
import TheSnackbar from '../TheSnackbar.vue'
import BaseIcon from '../base/BaseIcon.vue'
import TheFooter from '../footer/TheFooter.vue'
import ISocialShareBarLinkListEntryData from '../../shared/general/interfaces/ISocialShareBarLinkListEntryData'
import { ILink } from '../../shared/general/interfaces/ILink'
import getLinkObject from '../../shared/fsxa/services/LinkService'
import IReference from '../../shared/fsxa/interfaces/IReference'
import LocationSearch from '../LocationSearch/LocationSearch.vue'

interface IFooterLinkData {
  lt_link : string | IReference
  lt_target : boolean
  lt_text : string
  lt_title_text ?: string
  lt_link_params ?: string
}

interface IFooterNavData {
  id : string
  type : string
  sectionType : string
  previewId : string
  data : IFooterLinkData
}

interface ISocialMediaType {
  key : string
  value : string
}

interface ISocialMediaLinkData {
  lt_link : string
  lt_social_media_type : ISocialMediaType
  lt_target : boolean
  lt_whatsapp_phone_number ?: number
}

interface ISocialMediaFooterNavData {
  id : string
  type : string
  sectionType : string
  previewId : string
  data : ISocialMediaLinkData
}

interface ISidebar {
  component ?: string
  props : any
}

@Component({
  name: 'PageFooter',
  components: {
    BaseIcon,
    TheSnackbar,
    TheFooter,
    LocationSearch, // used in sidebar component
    TheSidebar: () => import('../layouts/TheSidebar.vue'),
    TheSocialShareBar: () => import('../layouts/TheSocialShareBar.vue'),
  },
})
export default class PageFooter extends FSXABaseComponent {
  private get showSocialShareBar () : boolean {
    return !!this.globalSettings?.data?.ps_country_project_settings?.pt_activate_social_share_bar
      && this.$store.state.SocialSharing.displaySocialShareBar
  }

  private get socialShareBarNetworks () : string[] {
    const shareBarLinkList = this.globalSettings
      ?.data?.ps_country_project_settings?.pt_social_share_bar_linklist as ISocialShareBarLinkListEntryData[]

    return shareBarLinkList
      ?.map((link) => link?.data?.lt_social_media_type?.key)
      // TODO: this should be removed as soon as the package "ShareNetwork" supports x.com instead of twitter.com
      .map((type) => (type === 'x' ? 'twitter' : type))
      .filter((key) => !!key)
  }

  private get footerNavElements () : ILink[] {
    return this.globalSettings?.data.ps_footer?.pt_nav_linklist?.map(
      (item : IFooterNavData) => getLinkObject(item, this.getUrlByPageId),
    ) || []
  }

  private get footerSocialMediaElements () : ILink[] {
    return this.globalSettings?.data.ps_footer?.pt_social_linklist?.map(
      (item : ISocialMediaFooterNavData) => getLinkObject(item, this.getUrlByPageId),
    ) || []
  }

  private get hasToolbarElements () : boolean {
    return this.$store.state.ToolbarElements.fixedElements.length || this.$store.state.ToolbarElements.elements.length
  }

  private get sidebar () : ISidebar {
    return {
      component: this.$store.state.SidebarContent.component,
      props: this.$store.state.SidebarContent.props,
    }
  }
}
